module.exports = function getResource(label, vars = []) {
    let resources = {
        search: 'Search',
        cancel: 'Cancel',
        previousSearches: 'Previous Searches',
        clearInputAriaLabel: 'clear search input text'
    };

    return resources[label];
};
